/**
 * Application-wide constants
 * Centralizes magic numbers and configuration values
 */

// Form Validation
export const FORM_CONSTANTS = {
  MAX_TEXT_LENGTH: 3000,
  DEFAULT_LANGUAGE_ID: 1,
} as const;

// Language Mappings
export const LANGUAGE_CODE_MAP: Record<number, string> = {
  1: "en-US",
  2: "nb-NO",
  3: "da-DK",
  4: "sv-SE",
} as const;

// Question Type Labels
export const QUESTION_TYPE_LABELS: Record<number, string> = {
  1: "NPS",
  2: "Rating",
  3: "FreeText",
} as const;

// Scale Descriptions
export const SCALE_DESCRIPTIONS = {
  NPS: {
    min: "Not at all likely",
    max: "Extremely likely",
  },
  RATING: {
    min: "Very Poor",
    max: "Excellent",
  },
} as const;

// UI Constants
export const UI_CONSTANTS = {
  STAR_SIZE: 24,
  FLAG_WIDTH: 20,
  FLAG_HEIGHT: 14,
  MAX_FORM_WIDTH: "648px",
} as const;

// API Constants
export const API_CONSTANTS = {
  FORM_STATUS_SUBMITTED: 2,
  DEFAULT_CHARSET: "utf-8",
} as const;